import { Link } from '@tanstack/react-router';
import { type FC } from 'react';

import {
  CardContent,
  type CardContentGridProps,
} from '$/components/common/Card/CardContent';
import { imageEndpoints } from '$/services/endpoints';

interface Props extends CardContentGridProps {
  id: string;
  label: string;
}

export const InspirationCard: FC<Props> = ({ label, id, ...props }) => {
  return (
    <Link to='/inspirations/$id' params={{ id }}>
      <CardContent
        label={label}
        image={imageEndpoints.inspirationThumbnail(id)}
        bg='transparent'
        {...props}
      />
    </Link>
  );
};
